import { LOCAL_PORTFOLIO_STORAGE_SCHEMA_VERSION } from "./constants";

const LEGACY_STORAGE_ENVELOPE_VERSIONS = new Set([1, 2, 3]);

/**
 * Promotes legacy outer envelopes before strict current-schema validation.
 * Nested portfolio data is intentionally left byte-for-byte equivalent.
 */
export function migrateLocalPortfolioStorageEnvelope(
  input: unknown,
): unknown {
  if (
    typeof input !== "object"
    || input === null
    || Array.isArray(input)
  ) {
    return input;
  }

  const record = input as Record<string, unknown>;
  if (
    typeof record.storageSchemaVersion !== "number"
    || !LEGACY_STORAGE_ENVELOPE_VERSIONS.has(
      record.storageSchemaVersion,
    )
  ) {
    return input;
  }

  return {
    ...record,
    storageSchemaVersion: LOCAL_PORTFOLIO_STORAGE_SCHEMA_VERSION,
  };
}
